// Application constants

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
  TOKEN: 'token', // Keep for backward compatibility
  USER_DATA: 'user',
  LOCALE: 'locale',
  THEME: 'theme',
  USER_PREFERENCES: 'user_preferences'
} as const

// Default locale
export const DEFAULT_LOCALE = 'ar'

// Theme constants
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system'
} as const
